export default __webpack_public_path__ + "static/media/agreedIcon.1e205e5a.svg";